import { StaticImage } from "gatsby-plugin-image";
import React, { useEffect, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import "./Header.scss";
import { List } from "react-bootstrap-icons";
import { Link } from "gatsby";

const Header = () => {
  //navbar scroll when active state
  const [navbar, setNavbar] = useState(false);

  //navbar scroll changeNavbar function
  const changeNavbar = () => {
    if (window.scrollY >= 50) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    changeNavbar();
    // adding the event when scroll
    window.addEventListener("scroll", changeNavbar);
  });

  return (
    <header>
      <Navbar
        collapseOnSelect
        expand="lg"
        className={navbar ? "navbar on-scroll" : "navbar"}
        fixed="top"
      >
        <Navbar.Brand href="/" className={`navbar--brand`}>
          <StaticImage
            className={
              navbar ? `navbar--brand--logo-on-scroll` : `navbar--brand--logo`
            }
            src="../../images/logo.png"
            loading="eager"
            alt="Saralee Deli logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          className="navbar--toggle"
        >
          <List className={`navbar--toggle--icon`} />
        </Navbar.Toggle>
        <Navbar.Collapse
          id="responsive-navbar-nav"
          className={`navbar--collapse flex-grow-0`}
        >
          <Nav className="navbar--collapse--nav">
            <Link
              className="navbar--collapse--nav--link"
              activeClassName="active"
              to="/inspirations"
            >
              INSPIRATIONS
            </Link>
            <Link
              className="navbar--collapse--nav--link navbar--collapse--nav--product-link"
              activeClassName="active"
              to="/turkey"
            >
              TURKEY
            </Link>
            <Link
              className="navbar--collapse--nav--link navbar--collapse--nav--product-link"
              activeClassName="active"
              to="/ham"
            >
              HAM
            </Link>
            <Link
              className="navbar--collapse--nav--link navbar--collapse--nav--product-link"
              activeClassName="active"
              to="/chicken"
            >
              CHICKEN
            </Link>
            <Link
              className="navbar--collapse--nav--link"
              activeClassName="active"
              to="/recipes"
            >
              RECIPES
            </Link>
            <Link
              className="navbar--collapse--nav--link"
              activeClassName="active"
              to="/about/our-story"
            >
              OUR STORY
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
};

export default Header;
